import { useEffect } from 'react';
import { Title, Box, Spinner } from '@nimbus-ds/components';
import { useParams } from 'react-router-dom';
import { useDesktopMenuContext } from 'App/components/Menu/DesktopMenuProvider';
import { IonPageStratus } from 'commons/components';
import { CheckoutProvider } from 'domains/Billing/Checkout/CheckoutUI';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { DomainsCheckout } from './components';
import { useGetDomainOrderQuery } from '../../domainsApi';
import './DomainsCheckoutPage.scss';

interface DomainsCheckoutPageParams {
  payOrderId: string;
}

export function DomainsCheckoutPage() {
  const t = useTranslationConfigurations('domains.checkout');
  const { hideMenu, showMenu } = useDesktopMenuContext();
  const { payOrderId } = useParams<DomainsCheckoutPageParams>();

  const { data: orderData, isLoading } = useGetDomainOrderQuery(
    payOrderId ?? '',
    {
      skip: !payOrderId,
    },
  );

  useEffect(() => {
    hideMenu();

    return () => {
      showMenu();
    };
  }, [hideMenu, showMenu]);

  return (
    <IonPageStratus width="medium">
      {isLoading || !orderData || !payOrderId ? (
        <Box padding="4" display="flex" justifyContent="center">
          <Spinner />
        </Box>
      ) : (
        <Box padding="4">
          <Title>
            {t('pageTitle')} {orderData?.domainName}
          </Title>
          <CheckoutProvider payOrderId={payOrderId}>
            <DomainsCheckout order={orderData} />
          </CheckoutProvider>
        </Box>
      )}
    </IonPageStratus>
  );
}
